import { render, staticRenderFns } from "./InformacoesUteis.vue?vue&type=template&id=c4d802ae&scoped=true"
import script from "./InformacoesUteis.vue?vue&type=script&lang=js"
export * from "./InformacoesUteis.vue?vue&type=script&lang=js"
import style0 from "./InformacoesUteis.vue?vue&type=style&index=0&id=c4d802ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d802ae",
  null
  
)

export default component.exports